<div
    class="split-pane tw-h-full tw-w-full tw-flex tw-flex-col tw-gap-1 sm:tw-flex-row tw-overflow-hidden"
    #splitPane>
    <div
        [ngClass]="{
            'left-pane tw-w-full': true,
            'tw-overflow-auto': !isPdfViewer,
            'tw-invisible': leftSideHidden(),
            '!tw-w-0': leftSideHidden(),
        }"
        #leftPane>
        <ng-content select="[leftPane]"></ng-content>
    </div>
    <div
        class="divider tw-flex tw-items-center tw-justify-center tw-h-full tw-w-full sm:tw-w-4 tw-bg-gray-200 tw-cursor-row-resize sm:tw-cursor-col-resize"
        #divider
        [ngClass]="{
            'tw-invisible': leftSideHidden(),
            '!tw-w-0': leftSideHidden(),
        }"
        (mousedown)="onStart($event)"
        (touchstart)="onStart($event)">
        <span></span>
    </div>
    <div
        class="right-pane tw-overflow-auto tw-w-full"
        #rightPane
        [ngClass]="{
            '!tw-w-full': leftSideHidden(),
        }">
        <ng-content select="[rightPane]"></ng-content>
    </div>
</div>
